import service from "@/store/services/boarding-service";

const state = {
  list: {},
  boarding: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, boarding) => {
    state.boarding = boarding;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  get({ commit, dispatch }, params) {
    return service.get(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },

  getlistado({ commit, dispatch }, params) {
    return service.getlistado(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },

  searchTicket({ commit, dispatch }, params) {
    return service.searchTicket(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },

  confirmDeparture({ commit, dispatch }, params) {
    return service.confirmDeparture(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },

  confirmBoarding({ commit, dispatch }, params) {
    return service.confirmBoarding(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },

  canjeBlanco({ commit, dispatch }, params) {
    return service.canjeBlanco(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },

  confirmBoardingBaggage({ commit, dispatch }, params) {
    return service.confirmBoardingBaggage(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },

  getlistadoFdt({ commit, dispatch }, params) {
    return service.getlistadoFdt(params).then(boarding => {
      commit("SET_RESOURCE", boarding);
    });
  },
};

const getters = {
  list: state => state.list,
  boarding: state => state.boarding,
  get: state => state.boarding,
  searchTicket: state => state.boarding,
  confirmDeparture: state => state.boarding,
  confirmBoarding: state => state.boarding,
  confirmBoardingBaggage: state => state.boarding,
  canjeBlanco: state => state.boarding,
  getlistado: state => state.boarding,
  getlistadoFdt: state => state.boarding,
  dropdown: state => {
    return state.list.map(boarding => ({
      id: boarding.id,
      nombre: boarding.nombre,
      abreviatura: boarding.abreviatura
    }));
  }
};

const boarding = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default boarding;
